import React from 'react';
import {observer} from 'mobx-react';
import {Approvers, Employees, PolicyDetails, Review} from './components';

const Steps = observer(({step, uiState}) => {
  switch (step) {
    case 'policy_details':
      return <PolicyDetails uiState={uiState}/>;
    case 'approvers':
      return <Approvers uiState={uiState}/>;
    case 'employees':
      return <Employees uiState={uiState}/>;
    case 'review':
      return <Review uiState={uiState}/>;
    default:
      throw new Error(`Location ${step} is not supported.`);
  }
});

export default Steps;
